import { Pipe, PipeTransform } from '@angular/core';
import { LocalizedStringDto } from '@data-access/bulk-operations-api';

import { getTranslationFromLocalizedString } from '../helpers/localized-string.helper';

/**
 * Pipe for extracting localized string values from LocalizedStringDto objects.
 * Returns the appropriate translation based on the current locale.
 *
 * @example
 * ```html
 * <span>{{ timeAgreementName | localizedString }}</span>
 * ```
 */
@Pipe({
  name: 'localizedString',
  standalone: true,
})
export class LocalizedStringPipe implements PipeTransform {
  /**
   * Transforms a LocalizedStringDto to its localized string value.
   * @param value - The LocalizedStringDto to transform
   * @returns The localized string for the current locale
   */
  transform(value: LocalizedStringDto): string {
    return getTranslationFromLocalizedString(value);
  }
}
